export enum RecipientsProviderType {
    EntityCreator = 'entity-creator',
    EntityInvoiceCreator = 'entity-invoice-creator',
    BusinessContacts = 'business-contacts',
    BusinessEmail = 'business-email',
    Email = 'email',
    Intent = 'intent',
    Comment = 'comment',
    EntityEmails = 'entity-emails',
}
